// Angular Files
import {
 Component, OnInit, OnDestroy, Input, Output, EventEmitter
} from '@angular/core';

// Angular Material Files
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

// Other External Files

// Component Files

// Teller Online Files
import { Country } from 'apps/public-portal/src/app/shared/constants';

// Teller Online Library Files
import { TellerOnlineValidationService } from 'libraries/shared/src/lib/services/validation.service';
import { PaymentMethodModel, TellerOnlinePaymentMethodsService } from '../../services/payment-methods.service';
import { TellerOnlineAppService } from '../../services/app.service';

@Component({
    selector: 'app-payment-method',
    templateUrl: './payment-method.component.html',
    styleUrls: ['./payment-method.component.scss'],
    standalone: false
})
export class TellerOnlinePaymentMethodComponent {
    // Public variables
    @Input() public readOnly: boolean = false;

    @Input() public paymentMethod: PaymentMethodModel;

    @Input() public isDefault: boolean;

    @Input() public emailIsVerified: boolean;

    @Output() remove = new EventEmitter<any>();

    @Output() default = new EventEmitter<any>();

    @Output() reacknowledgeRequested = new EventEmitter<PaymentMethodModel>();

    // Private variables

    // Subscriptions

    constructor(
        private validationService: TellerOnlineValidationService,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
        public appService: TellerOnlineAppService,
        public paymentMethodsService: TellerOnlinePaymentMethodsService
    ) {
        // Registered here (not just by the payment-integration form components) since this
        // component also renders standalone on the read-only Payment Methods list, where none
        // of those form components are ever instantiated — and it's shared by both portals
        // (admin-portal's user/payment-methods page uses it too). Root-relative (any number of
        // leading "../" collapses at the document's <base href>, same as the existing
        // registration in base-payment-processor.component.ts) so it resolves against whichever
        // portal is actually running — each portal ships its own /assets/icons/echeck-icon.svg.
        this.matIconRegistry.addSvgIcon(
            'echeck-start',
            this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/echeck-icon.svg')
        );
    }

    // TODO (TOP-2185): Re-evaluate how phone number formatting is determined
    public isNorthAmerica() {
        const country = Country.GetByCode(this.paymentMethod.addressCountry) ?? Country.GetByName(this.paymentMethod.addressCountry) ?? null;

        if (!country) return false;
        return this.validationService.checkPhoneNumberNorthAmerica(country.dial_code);
    }

    public onClick_removeMethod(e, paymentMethod) {
        this.remove.emit({ event: e, paymentMethod });
    }

    public onChange_setDefault(paymentMethod) {
        this.default.emit(paymentMethod);
    }

    public onClick_reacknowledge() {
        this.reacknowledgeRequested.emit(this.paymentMethod);
    }
}
